import { Component, Input } from '@angular/core';

@Component({
    selector: 'syn-detail-card-field',
    templateUrl: './detail-card-field.component.html',
    styleUrls: ['./detail-card-field.component.scss']
})
export class DetailCardFieldComponent {
    @Input() label = '';
    @Input() labelCaption: string;
    @Input() isValid = true;
    @Input() defaultValue = 'N/A';
    @Input() centeredValue = false;
}
